export const ProjectList = [
    {
        company: "GDSC Portfolio",
        timeline: "July 2023 - Aug 2023",
        description: `Crafted a dynamic GDSC’23 MGMCET portfolio, redefining student engagement and amplifying societal influence. Meticulously sculpted a platform that fostered lasting connections, resonating with the audience and expanding the club’s impact significantly.`,
        skills: ['React', 'styled-components','Framer Motion','locomotive-scroll','css-doodle'],
        github: 'https://github.com/HimanshuBhoir/gdsc-mgmcet.github.io',
    },
    {
        company: "Advisely",
        timeline: "Jan 2023 - Mar 2023",
        description: `Engineered Advisely's ZegoCloud-powered video consultation platform, seamlessly connecting consumers with professionals across diverse services. Streamlined processes saved 17% time, ensuring robust security, and optimizing UI with MERN Stack for enhanced responsiveness and usability.`,
        skills: ['React','NodeJS','Express','MongoDB','ZegoCloud'],
        github: 'https://github.com/HimanshuBhoir/Advisely',
    },
    {
        company: "Raise-IT",
        timeline: "Sep 2022 - Nov 2022",
        description: `Sparked active community engagement, fueling regional awareness for 40% of socially active adults. Crafted a secure, intuitive platform for vibrant discussions, trends, and voting experiences.`,
        skills: ['React','NodeJS','Express','MongoDB','Cloudinary'],
        github: 'https://github.com/HimanshuBhoir/host',
    },
    {
        company: "Spring Boot Microservices",
        timeline: "Dec 2023 - Working",
        description: `Creating Spring Boot microservices for an electrical shop's e-commerce, exploring server coordination to achieve full automation and streamlined operations.`,
        skills: ['Java', 'MySQL', 'SpringBoot', 'Maven', 'Postman'],
        github: 'https://github.com/HimanshuBhoir/SpringBoot-Microservices',
    },
    {
        company: "FOODOFAST",
        timeline: "Jul 2021 - Sep 2021",
        description: `Revolutionized food ordering and payment through independent systems, significantly enhancing efficiency compared to traditional methods. Elevated user interface functionality using Java and Swing, ensuring seamless interactions and improved user satisfaction.`,
        skills: ['Java','MySQL','Swing'],
        github: 'https://github.com/HimanshuBhoir/FoodoFast',
    }
]

